<template>
  <div class="search" @keyup.esc="rootClose" v-click-outside="close">
    <input
      type="text"
      class="form-control navbar-text mx-2 navbar-search"
      placeholder="Map search..."
      v-model="term"
      @keyup="search"
      @focusin.stop="open"
      tabindex="0"
      @blur="blurClose"
      @keydown="blurCloseBlock"
      ref="searchInput"
    />
    <div v-if="resultsEnabled" class="search-result" @mousedown="blurCloseBlock" @mouseup="blurCloseUnblock" tabindex="-1">
      <ul class="search-result-list" v-if="computedPoints.length" @keyup.arrow-down="down" @keyup.arrow-up="up" tabindex="-1">
        <li v-for="(point, num) in computedPoints" :key="`point-${point.id}`" tabindex="-1">
          <a
            href="#"
            @click.prevent
            :id="`search-item-${num}`"
            :tabindex="getTabindexAndFocus(num)"
            @keyup.enter="goToPoint(point)"
            class="search-item-link"
          >
            <app-nav-search-item :point="point" @go="goToPoint" tabindex="-1" />
          </a>
        </li>
      </ul>
      <div v-else class="search-empty-result" v-text="searchTextStatus" tabindex="-1"></div>
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/Api'
import US from '@/utils/UrlStore'
import AppNavSearchItem from '@/components/core/AppNavSearchItem'
import { POINT_ICONS } from '@/store/modules/point'
import { mapActions } from 'vuex'
import { navigate } from '@/router/navigation'

export default {
  name: 'app-nav-search',
  components: { AppNavSearchItem },
  data: () => ({
    points: [],
    term: '',
    resultsEnabled: false,
    searchInProgress: false,
    blurCloseBlocked: false,
    activeItemNum: null
  }),
  computed: {
    searchTextStatus() {
      if (this.searchInProgress) {
        return 'search in progress...'
      }
      return 'results not found...'
    },
    computedPoints() {
      return this.points.filter((p) => !(p.icon_id === POINT_ICONS.EMPLOYEE && !p.employee))
    }
  },
  methods: {
    rootClose() {
      this.$refs.searchInput.blur()
      this.close()
    },
    down() {
      if (this.activeItemNum + 1 >= this.points.length) {
        return
      }
      this.activeItemNum++
    },
    up() {
      if (this.activeItemNum - 1 < 0) {
        return
      }
      this.activeItemNum--
    },
    getTabindexAndFocus(num) {
      if (num === this.activeItemNum) {
        this.$nextTick(() => {
          let el = document.getElementById(`search-item-${num}`)
          if (el) {
            el.focus()
          }
        })
        return '0'
      }

      if (num === 0 && this.activeItemNum === null) {
        return '0'
      }

      return '-1'
    },
    blurClose() {
      if (!this.blurCloseBlocked) {
        this.close()
      }
    },
    blurCloseUnblock() {
      this.blurCloseBlocked = false
    },
    blurCloseBlock() {
      this.blurCloseBlocked = true
    },
    clear() {
      this.points = []
      this.term = ''
      this.activeItemNum = null
    },
    goToPoint(point) {
      this.resultsEnabled = false
      // the address only: the map follows it, and setting the map state as well made the map
      // push the same address a second time
      navigate(this.$router, { name: 'map', params: { floorId: point.floor_id }, query: { pointId: point.id } })
    },
    open() {
      this.resultsEnabled = true
      this.activeItemNum = null
      this.search(this.term)
    },
    close() {
      this.clear()
      this.resultsEnabled = false
    },
    search(event) {
      if (!this.resultsEnabled) return
      this.searchInProgress = true
      const term = event instanceof Event ? event.target.value : event
      get(US.POINTS, {
        params: {
          pagination: true,
          'per-page': 50,
          filters: { term },
          expand: 'room,employee,printer,desk,deskEvents,pc'
        }
      }).then((r) => {
        this.points = r.data
        this.searchInProgress = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.search {
  width: 200px;

  &-result {
    position: absolute;
    background: #fff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
    max-height: 70vh;
    overflow-y: auto;

    &-list {
      padding: 0;
      list-style: none;
      color: #4e5155;
    }
  }

  &-empty-result {
    color: #4e5155;
    text-align: center;
    padding: 1rem;
  }

  &-item-link {
    -ms-user-select: text;
  }
}

.navbar-search::placeholder {
  color: #f7f7f7 !important;
}
</style>
